import * as Yup from 'yup'
import { FormItemProps } from '@/components/Form/types'

export const changePasswordFormItems = (): Array<FormItemProps> => [
  {
    name: 'password',
    label: 'New Password',
    placeholder: 'Enter new password',
    type: 'Password',
    defaultValue: '',
    validation: Yup.string()
      .min(8, 'Password must be at least 8 characters')
      .required('Password is required'),
    classNames: { container: 'col-span-12' },
    autoFocus: true,
  },
]
